module.exports = __webpack_public_path__ + "img/pop_appDownload_PCDXZQD.d37acbf0.png";